<template>
  <div class="">

    <div class="form-info-box clearfix">
      <div class="form-check-info">
        <div>User Name：<span>{{ formData.input1 }}</span></div>
        <div>Company Email：<span>{{ formData.input2 }}</span></div>
        <div>Mobile Phone：<span>{{ formData.input3 }}</span></div>
        <div>Status：<span>{{ formData.input4 }}</span></div>
        <div>Role：<span>{{ formData.input5 }}</span></div>
      </div>
    </div>

    <div class="table-content-box">
      <el-tree
        :data="data"
        show-checkbox
        node-key="id"
        :default-expanded-keys="[2, 3]"
        :default-checked-keys="[5]"
        :props="defaultProps"
      />

      <div class="btnList">
        <el-button type="primary" round>Cancel</el-button>
        <el-button type="primary" round>Add</el-button>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {

      pageNumber: 1,
      total: 0,

      formData: {
        input1: 'Cathy',
        input2: 'About',
        input3: '188888888888',
        input4: 'about',
        input5: 'admin'
      },

      data: [{
        id: 1,
        label: '一级 1',
        children: [{
          id: 4,
          label: '二级 1-1'
        }]
      }, {
        id: 2,
        label: '一级 2',
        children: [{
          id: 5,
          label: '二级 2-1'
        }, {
          id: 6,
          label: '二级 2-2'
        }]
      }, {
        id: 3,
        label: '一级 3',
        children: [{
          id: 7,
          label: '二级 3-1'
        }, {
          id: 8,
          label: '二级 3-2'
        }, {
          id: 9,
          label: '二级 3-3'
        }, {
          id: 10,
          label: '二级 3-4'
        }, {
          id: 11,
          label: '二级 3-5'
        }, {
          id: 12,
          label: '二级 3-6'
        }, {
          id: 13,
          label: '二级 3-7'
        }, {
          id: 14,
          label: '二级 3-8'
        }]
      }],
      defaultProps: {
        children: 'children',
        label: 'label'
      }

    }
  },
  mounted() {},
  methods: {

  }
}
</script>

<style scoped lang="scss">

  .btnList{
    margin-bottom: 20px;
    margin-top: 20px;
    text-align: center;
    border-radius: 10px;
  }

</style>
